import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub personal-order-project-detail" }
const _hoisted_4 = { style: {"height":"auto"} }
const _hoisted_5 = {
  key: 0,
  class: "loading-indicator",
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_6 = {
  key: 1,
  style: {"text-align":"center","padding":"20px","color":"#888"}
}
const _hoisted_7 = {
  key: 2,
  class: "split-view-container"
}
const _hoisted_8 = { class: "left-class-list" }
const _hoisted_9 = { class: "list-subtitle" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "right-details-area" }
const _hoisted_12 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  style: {"color":"red"}
}
const _hoisted_16 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  style: {"color":"#d03050","font-weight":"600"}
}
const _hoisted_20 = { style: {"display":"flex","flex-wrap":"wrap","gap":"10px","align-items":"center"} }
const _hoisted_21 = {
  key: 1,
  class: "examinee-creation-section"
}
const _hoisted_22 = {
  key: 2,
  style: {"margin-top":"10px","text-align":"center","color":"#888"}
}
const _hoisted_23 = { style: {"margin-top":"30px","text-align":"right","margin-left":"80px","min-width":"800px","max-width":"1000px"} }

import { ref, onMounted, h, computed, onUnmounted } from "vue";
import MypageSidebar from "@/views/member/MypageSidebar.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter, useRoute } from "vue-router";
import {
  NSpace,
  NCard,
  NButton,
  NDescriptions,
  NDescriptionsItem,
  NDataTable,
  DataTableColumns,
  useNotification,
  useMessage,
  useDialog,
  NIcon,
  NModal,
  NCheckbox,
  NInput,
  NTag,
  NTooltip,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import {
  getCallable,
  getCallableOption,
  getRequestEndpoint,
} from "@/config/env";
import * as common from "@/assets/common/common";
import { getAuth } from "firebase/auth";
import * as constant from "@/constants/constant";
import { Order, OrderItem } from "@/model/order";
import { Project } from "@/model/project";
import { Examinee } from "@/model/examinee";
import { RefreshOutline as RefreshIcon } from "@vicons/ionicons5";
import { getProjectStatusString } from "@/composables/useOrderForm";
import { useDownload } from "@/composables/useDownload";
import { useActionDialog } from "@/composables/useDialog";
import { useAuth } from "@/composables/useAuth";
interface ExamineeTableProps {
  examinees: Examinee[];
  status?: string;
  classType?: string;
  project?: Project;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrgOrderProjectDetail',
  setup(__props) {

const { downloadReportFile } = useDownload();

const { show: showActionDialog } = useActionDialog();

const { isOrgAdmin } = useAuth();

const router = useRouter();
const route = useRoute();
const notification = useNotification();
const message = useMessage();
const dialog = useDialog();
const auth = getAuth();

const pageLoading = ref(true);
const isDoingJob = ref(false);
const isTeacherReporting = ref<{ [key: string]: boolean }>({});
const isStudentReporting = ref<{ [key: string]: boolean }>({});
const isProjectOpening = ref<{ [key: string]: boolean }>({});
const isProjectClosing = ref<{ [key: string]: boolean }>({});
const isDownloadingStudentReport = ref<{ [key: string]: boolean }>({});
const isSendingStudentEmail = ref<{ [key: string]: boolean }>({});

const order = ref<Order>();
const activeClassIndex = ref(0); // 현재 활성화된 학급 목록 항목 인덱스
const orderProjectEntries = ref<Project[]>(); // Changed to Project[] for clarity

const isManagerModalOpen = ref(false);
const orgMembers = ref<any[]>([]);
const loadingMembers = ref(false);
const memberSearchQuery = ref("");
const isIncludeAdmin = ref(false);
const isUpdatingManager = ref(false);

const getOrderProjectsCallable = getCallable(
  "getOrderProjectsContainsExamninees"
);
const openOneProjectCallable = getCallable("openOneProject");
const requestProjectReportGenerationCallable = getCallableOption(
  "requestProjectReportGeneration"
);
const requestTeacherReportGenerationCallable = getCallableOption(
  "requestTeacherReportGeneration"
);
const closeOneProjectCallable = getCallable("closeOneProject");
const getProjectCallable = getCallable("getProject");
const getProjectContainsExamnineesCallable = getCallable("getProjectContainsExamninees");
const updateProjectManagerCallable = getCallable("updateProjectManager");
const getOrgMembersCallable = getCallable("getOrgMembers");
const sendExamineeReportEmailCallable = getCallable("sendExamineeReportEmail");
const updateExamineeEmailCallable = getCallable("updateExamineeEmail");


const filteredOrgMembers = computed(() => {
  return orgMembers.value.filter((member) => {
    // 1. 관리자 포함 여부 필터
    if (!isIncludeAdmin.value && member.type === "admin") {
      return false;
    }
    // 2. 이름 또는 이메일 검색 필터
    if (memberSearchQuery.value.trim()) {
      const q = memberSearchQuery.value.toLowerCase().trim();
      const nameMatch = member.name?.toLowerCase().includes(q);
      const emailMatch = member.email?.toLowerCase().includes(q);
      return nameMatch || emailMatch;
    }
    return true;
  });
});

const memberTableColumns = [
  {
    title: "이름",
    key: "name",
  },
  {
    title: "이메일",
    key: "email",
  },
  {
    title: "역할",
    key: "role",
    render(row: any) {
      return row.role || "-";
    }
  },
  {
    title: "직책",
    key: "position",
    render(row: any) {
      return row.position || "-";
    }
  },
  {
    title: "구분",
    key: "type",
    render(row: any) {
      return row.type === "admin" ? "관리자" : "사용자";
    }
  },
  {
    title: "선택",
    key: "actions",
    render(row: any) {
      return h(
        NButton,
        {
          size: "small",
          type: "info",
          disabled: isUpdatingManager.value,
          onClick: () => selectManager(row),
        },
        { default: () => "선택" }
      );
    }
  }
];

async function fetchSingleProjectDetails(projectSK: string, index: number, silent = false) {
  if (!silent) {
    pageLoading.value = true;
  }
  try {
    const projectResult = await getProjectCallable({ SK: projectSK });
    const examineesResult = await getProjectContainsExamnineesCallable({ SK: projectSK });

    if (common.evalFunctionResult(projectResult) && common.evalFunctionResult(examineesResult)) {
      const projectData = common.getItemFromFunctionResult(projectResult) as Project;
      const examineesData = common.getItemListFromFunctionResult(examineesResult) as Examinee[];
      if (orderProjectEntries.value && orderProjectEntries.value[index]) {
        orderProjectEntries.value[index] = {
          ...projectData,
          examinees: examineesData,
        };
      }
    } else {
      console.error("진단 정보 개별 로딩 실패:", common.getResultError(projectResult) || common.getResultError(examineesResult));
      if (!silent) {
        notification.error({
          title: "로딩 실패",
          description: "진단 상세 정보를 불러오는 중 오류가 발생했습니다.",
          duration: 3000,
        });
      }
    }
  } catch (error: any) {
    console.error("진단 정보 개별 로딩 오류:", error);
    if (!silent) {
      notification.error({
        title: "로딩 실패",
        description: error || "진단 상세 정보를 불러오는 중 오류가 발생했습니다.",
        duration: 3000,
      });
    }
  } finally {
    if (!silent) {
      pageLoading.value = false;
    }
  }
}

async function fetchOrderProjectDetails(orderSK: string, silent = false) {
  if (!silent) {
    pageLoading.value = true;
  }
  const orderSKFromRoute = route.params.SK as string;
  if (!orderSKFromRoute) {
    pageLoading.value = false;
    notification.error({
      title: "오류",
      description: "견적 정보가 올바르지 않습니다. 견적 목록으로 돌아갑니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.Mypage.Order.Org.Name }); // Or a default order list route
    return; // Early exit if SK is not found
  }
  try {
    const result = await getOrderProjectsCallable({ SK: orderSK });
    if (common.evalFunctionResult(result)) {
      const orderProjectData = common.getItemListFromFunctionResult(
        result
      ) as Project[];
      if (orderProjectData && orderProjectData.length > 0) {
        orderProjectEntries.value = orderProjectData;
        activeClassIndex.value = 0; // 첫 번째 항목 활성화
      } else {
        notification.warning({
          title: "정보 없음",
          description:
            "해당 진단 정보를 찾을 수 없습니다. 또는 등록된 학급/학과 정보가 없습니다.",
          duration: 3000,
        });
        orderProjectEntries.value = []; // Clear existing data if any
      }
    } else {
      console.error("견적 상세 정보 로딩 실패:", common.getResultError(result));
      notification.error({
        title: "로딩 실패",
        description:
          common.getResultError(result) ||
          "견적 정보를 불러오는 중 오류가 발생했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    console.error("견적 상세 정보 로딩 실패:", error);
    notification.error({
      title: "로딩 실패",
      description: error || "견적 정보를 불러오는 중 오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    pageLoading.value = false;
  }
}

let isComponentMounted = true;
let refreshInterval: any = null;

onMounted(async () => {
  isComponentMounted = true;
  const orderSKFromRoute = route.params.SK as string;
  if (!orderSKFromRoute) {
    notification.error({
      title: "오류",
      description: "견적 정보가 올바르지 않습니다. 견적 목록으로 돌아갑니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.ORDER_LIST.NAME }); // Or a default order list route
    return;
  }
  await fetchOrderProjectDetails(orderSKFromRoute);

  if (isComponentMounted) {
    refreshInterval = setInterval(async () => {
      if (orderProjectEntries.value && orderProjectEntries.value[activeClassIndex.value]) {
        const activeProject = orderProjectEntries.value[activeClassIndex.value];
        if (activeProject && activeProject.SK) {
          await fetchSingleProjectDetails(activeProject.SK, activeClassIndex.value, true);
        }
      }
    }, 15000);
  }
});

onUnmounted(() => {
  isComponentMounted = false;
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
});

async function refreshData() {
  if (orderProjectEntries.value && orderProjectEntries.value[activeClassIndex.value]) {
    const activeProject = orderProjectEntries.value[activeClassIndex.value];
    if (activeProject && activeProject.SK) {
      await fetchSingleProjectDetails(activeProject.SK, activeClassIndex.value, false);
    }
  }
}

const getClassTitle = (classItem: Project, classIdx: number): string => {
  let typeName = "정보"; // 기본값
  if (classItem.type === "putt_u" || classItem.type === "tec") {
    typeName = "학과";
    // 학과명 + 학년 조합 (예: 컴퓨터공학과 1학년)
    if (classItem.major && classItem.grade)
      return `${classItem.major} ${classItem.grade}학년`;
    if (classItem.major) return `${classItem.major}`;
  } else {
    typeName = "학급";
    // 학년 + 반 조합 (예: 1학년 1반)
    if (classItem.grade && classItem.class)
      return `${classItem.grade}학년 ${classItem.class}반`;
  }
  return `${typeName} ${classIdx + 1}`;
};

const createExamineeTableColumns = (
  status: constant.orderStatus,
  classType?: string,
  project?: Project
): DataTableColumns<Examinee> => {
  const isUniversityType = classType === "putt_u" || classType === "tec";
  return [
    {
      title: "학생 정보 및 결과리포트 / 이메일 관리",
      key: "examinee_info",
      render: (row, idx) => {
        const isSent = !!row.email_sent;
        const hasEmail = !!row.email;
        const numLabel = isUniversityType ? "학번" : "번호";
        const numVal = isUniversityType
          ? row.student_num || row.num || "N/A"
          : row.num || "N/A";

        // 1행: 인증코드 | 번호/학번 | 성명 (성별 / 생년월일)
        const row1 = h(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
              paddingBottom: "8px",
              borderBottom: "1px dashed #e8e8e8",
              fontSize: "13px",
            },
          },
          [
            // 인증코드
            h(
              "span",
              { style: { display: "inline-flex", alignItems: "center", gap: "4px" } },
              [
                h("span", { style: { color: "#666" } }, "인증코드:"),
                h(
                  "strong",
                  { style: { color: "#e03131", letterSpacing: "0.5px", fontSize: "14px" } },
                  row.authCode || "N/A"
                ),
              ]
            ),
            h("span", { style: { color: "#d9d9d9" } }, "|"),
            // 번호 / 학번
            h(
              "span",
              { style: { display: "inline-flex", alignItems: "center", gap: "4px" } },
              [
                h("span", { style: { color: "#666" } }, `${numLabel}:`),
                h(
                  "span",
                  {
                    style: {
                      fontWeight: numVal !== "N/A" ? "bold" : "normal",
                      color: numVal !== "N/A" ? "#333" : "#999",
                    },
                  },
                  numVal
                ),
              ]
            ),
            h("span", { style: { color: "#d9d9d9" } }, "|"),
            // 성명 및 인적사항
            h(
              "span",
              { style: { fontWeight: "bold", fontSize: "14px", color: "#1f2225" } },
              row.name || "N/A"
            ),
            h(
              "span",
              { style: { color: "#666" } },
              `(${common.getGenderString(row.gender)} / ${row.dob || "생년월일 미등록"})`
            ),
          ]
        );


        // 2행: 결과리포트 및 이메일 전송/수정 영역
        let row2;
        if (row.report_file) {
          let tooltipText = "전송완료";
          if (row.email_sent_at) {
            try {
              const d = new Date(row.email_sent_at);
              if (!isNaN(d.getTime())) {
                tooltipText = `${common.formatDateToYYYYMMDD2(d)} 전송됨`;
              }
            } catch {}
          }

          row2 = h(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "12px",
                paddingTop: "8px",
              },
            },
            [
              // 좌측: 이메일 정보 & 전송 상태
              h(
                "div",
                { style: { display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" } },
                [
                  h(
                    "div",
                    { style: { display: "flex", alignItems: "center", gap: "6px" } },
                    [
                      h("span", { style: { fontSize: "13px", color: "#666" } }, "이메일:"),
                      h(
                        "span",
                        {
                          style: {
                            fontSize: "13px",
                            fontWeight: row.email ? "500" : "normal",
                            color: row.email ? "#1f2225" : "#999",
                          },
                        },
                        row.email || "미등록"
                      ),
                      h(
                        NButton,
                        {
                          size: "tiny",
                          quaternary: true,
                          type: "primary",
                          onClick: () => showEmailEditDialog(row),
                        },
                        { default: () => "수정" }
                      ),
                    ]
                  ),
                  h("span", { style: { color: "#d9d9d9" } }, "|"),
                  h(
                    "div",
                    { style: { display: "flex", alignItems: "center", gap: "6px" } },
                    [
                      h("span", { style: { fontSize: "13px", color: "#666" } }, "전송상태:"),
                      isSent
                        ? h(
                            NTooltip,
                            { trigger: "hover" },
                            {
                              trigger: () =>
                                h(
                                  NTag,
                                  { type: "success", size: "small", round: true, style: "cursor: pointer;" },
                                  { default: () => "전송완료" }
                                ),
                              default: () => tooltipText,
                            }
                          )
                        : h(
                            NTag,
                            {
                              size: "small",
                              round: true,
                              bordered: false,
                              style: "color: #999; background: #f0f0f0;",
                            },
                            { default: () => "미전송" }
                          ),
                    ]
                  ),
                ]
              ),
              // 우측: 결과리포트 액션 버튼들
              h(
                "div",
                { style: { display: "flex", alignItems: "center", gap: "8px" } },
                [
                  h(
                    NButton,
                    {
                      strong: true,
                      tertiary: true,
                      size: "small",
                      disabled: isDoingJob.value,
                      loading: isDownloadingStudentReport.value[row.SK] || false,
                      onClick: () => downloadExamineeReportFile(row, isUniversityType),
                    },
                    { default: () => "리포트 다운로드" }
                  ),
                  h(
                    NTooltip,
                    { trigger: "hover" },
                    {
                      trigger: () =>
                        h(
                          NButton,
                          {
                            type: isSent ? "warning" : "info",
                            size: "small",
                            disabled: !hasEmail || isDoingJob.value,
                            loading: isSendingStudentEmail.value[row.SK],
                            onClick: () => doSendExamineeEmail(row, project),
                          },
                          { default: () => (isSent ? "이메일 재전송" : "이메일 전송") }
                        ),
                      default: () =>
                        !hasEmail
                          ? "이메일 주소를 입력해주세요"
                          : isSent
                          ? "결과리포트 이메일 재전송"
                          : "결과리포트 이메일 전송",
                    }
                  ),
                ]
              ),
            ]
          );
        } else if (row.is_report_generating) {
          row2 = h(
            "div",
            { style: { paddingTop: "8px" } },
            [
              h(
                NButton,
                { strong: true, tertiary: true, size: "small", disabled: true, loading: true },
                { default: () => "결과리포트 생성 중..." }
              ),
            ]
          );
        } else {
          row2 = h(
            "div",
            { style: { paddingTop: "8px" } },
            [
              h(
                NTag,
                { size: "small", bordered: false, style: "color: #999; background: #f7f7f7;" },
                { default: () => "진단 미완료 (결과리포트 생성 전)" }
              ),
            ]
          );
        }

        return h(
          "div",
          {
            style: {
              padding: "10px 14px",
              background: "#fafafa",
              borderRadius: "6px",
              border: "1px solid #f0f0f0",
            },
          },
          [row1, row2]
        );
      },
    },
  ];
};

const ExamineeTable: FunctionalComponent<ExamineeTableProps> = (props) => {
  const columns = createExamineeTableColumns(props.status, props.classType, props.project);
  return h(NDataTable, {
    columns: columns,
    data: props.examinees,
    bordered: false,
    singleLine: false,
    size: "small",
    style: { marginTop: "15px" },
  });
};

function triggerOrderProjectsUpdate() {
  if (orderProjectEntries.value) {
    orderProjectEntries.value = orderProjectEntries.value.map((p) => ({
      ...p,
      examinees: p.examinees ? [...p.examinees] : [],
    }));
  }
}

function showEmailEditDialog(examinee: Examinee) {
  const newEmailRef = ref<string>(examinee.email || "");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const d = dialog.create({
    title: "학생 이메일 수정",
    content: () =>
      h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
        h("p", `"${examinee.name}" 학생의 이메일 주소를 입력해주세요.`),
        h(NInput, {
          value: newEmailRef.value,
          placeholder: "example@email.com",
          onUpdateValue: (value: string) => {
            newEmailRef.value = value;
          },
        }),
      ]),
    positiveText: "저장",
    negativeText: "취소",
    onPositiveClick: () => {
      const emailVal = newEmailRef.value.trim();
      if (!emailVal || !emailRegex.test(emailVal)) {
        message.error("올바른 이메일 형식을 입력해주세요.");
        return false;
      }
      d.loading = true;
      updateExamineeEmailCallable({
        examineeSK: examinee.SK,
        email: emailVal,
      })
        .then((res: any) => {
          if (common.evalFunctionResult(res)) {
            examinee.email = emailVal;
            triggerOrderProjectsUpdate();
            message.success("이메일이 성공적으로 수정되었습니다.");
            d.destroy();
          } else {
            d.loading = false;
            notification.error({
              title: "이메일 수정 실패",
              description: common.getResultError(res) || "이메일 수정에 실패했습니다.",
              duration: 3000,
            });
          }
        })
        .catch((err: any) => {
          d.loading = false;
          notification.error({
            title: "오류 발생",
            description: err.message || "이메일 수정 중 오류가 발생했습니다.",
            duration: 3000,
          });
        });

      return false;
    },
  });
}


function doSendExamineeEmail(examinee: Examinee, project: Project | undefined) {
  if (!project) return;
  if (!examinee.email) {
    message.warning("학생의 이메일 주소가 등록되지 않았습니다.");
    return;
  }
  if (!examinee.report_file) {
    message.warning("결과리포트가 아직 생성되지 않았습니다.");
    return;
  }

  const isResend = !!examinee.email_sent;
  const d = dialog.create({
    title: isResend ? "결과리포트 이메일 재전송" : "결과리포트 이메일 전송",
    type: isResend ? "warning" : "info",
    content: () =>
      h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
        isResend
          ? h("p", { style: "color: #e6a23c; font-weight: bold;" }, "이미 이메일이 전송된 학생입니다.")
          : null,
        h(
          "p",
          `"${examinee.name}" 학생(${examinee.email})에게 결과리포트 이메일을 ${isResend ? "다시 " : ""}전송하시겠습니까?`
        ),
      ]),
    positiveText: "전송",
    negativeText: "취소",
    onPositiveClick: () => {
      d.loading = true;
      isSendingStudentEmail.value[examinee.SK] = true;
      sendExamineeReportEmailCallable({
        projectSK: project.SK,
        examineeSK: examinee.SK,
      })
        .then((res: any) => {
          if (common.evalFunctionResult(res)) {
            const payload = res.data?.data || res.data || {};
            examinee.email_sent = true;
            examinee.email_sent_at = payload.email_sent_at || new Date().toISOString();
            triggerOrderProjectsUpdate();
            message.success("이메일이 성공적으로 전송되었습니다.");
            d.destroy();
          } else {
            d.loading = false;
            notification.error({
              title: "이메일 전송 실패",
              description: common.getResultError(res) || "이메일 전송에 실패했습니다.",
              duration: 3000,
            });
          }
        })
        .catch((err: any) => {
          d.loading = false;
          notification.error({
            title: "오류 발생",
            description: err.message || "이메일 전송 중 오류가 발생했습니다.",
            duration: 3000,
          });
        })
        .finally(() => {
          isSendingStudentEmail.value[examinee.SK] = false;
        });

      return false;
    },
  });
}




async function doOpenProject(projectSK: string) {
  isDoingJob.value = true;
  isProjectOpening.value[projectSK] = true;
  try {
    const result = await openOneProjectCallable({ SK: projectSK });
    if (common.evalFunctionResult(result)) {
      notification.warning({
        title: "요청 성공",
        description: "검사 오픈 요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) || "검사 오픈 요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "검사 오픈 요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    isProjectOpening.value[projectSK] = false;
    isDoingJob.value = false;
  }
}

async function downloadTeacherReportFile(projectItem: Project) {
  pageLoading.value = true;
  let filename = "";
  if (projectItem.type == "putt_u" || projectItem.type == "tec") {
    filename = `${projectItem.major}_${projectItem.class}학년.xlsx`;
  } else {
    filename = `${projectItem.grade}학년_${projectItem.class}반.xlsx`;
  }
  await downloadReportFile(projectItem.teacher_report_file, filename);
  pageLoading.value = false;
}
async function downloadExamineeReportFile(
  examineeItem: Examinee,
  isUniversityType: boolean
) {
  isDoingJob.value = true;
  isDownloadingStudentReport.value[examineeItem.SK] = true;
  const numStr = isUniversityType ? examineeItem.student_num : examineeItem.num;
  const projectType = orderProjectEntries.value
    ? orderProjectEntries.value[activeClassIndex.value].type
    : "";
  let typePrefix = "";
  if (projectType) {
    typePrefix = projectType.split("_")[0].toUpperCase() + "-";
  }
  let filename = `${typePrefix}${numStr}_${examineeItem.name}.pdf`;
  await downloadReportFile(examineeItem.report_file, filename);
  isDownloadingStudentReport.value[examineeItem.SK] = false;
  isDoingJob.value = false;
}

async function doRequestTeacherReport(projectSK: string) {
  isDoingJob.value = true;
  isTeacherReporting.value[projectSK] = true;
  try {
    const result = await requestTeacherReportGenerationCallable({
      SK: projectSK,
    });
    if (common.evalFunctionResult(result)) {
      if (orderProjectEntries.value && orderProjectEntries.value[activeClassIndex.value] && orderProjectEntries.value[activeClassIndex.value].SK === projectSK) {
        orderProjectEntries.value[activeClassIndex.value].is_teacher_report_generating = true;
      }
      notification.warning({
        title: "요청 성공",
        description: "결과리포트_담임용 생성요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) ||
          "결과리포트_담임용 생성요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "결과리포트_담임용 생성요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    isTeacherReporting.value[projectSK] = false;
    isDoingJob.value = false;
  }
}
async function doRequestExamineeReport(projectSK: string) {
  isDoingJob.value = true;
  isStudentReporting.value[projectSK] = true;
  try {
    const result = await requestProjectReportGenerationCallable({
      SK: projectSK,
    });
    if (common.evalFunctionResult(result)) {
      const skList = result.data.data;
      if (orderProjectEntries.value && orderProjectEntries.value[activeClassIndex.value] && orderProjectEntries.value[activeClassIndex.value].SK === projectSK) {
        const examinees = orderProjectEntries.value[activeClassIndex.value].examinees;
        if (examinees && skList && Array.isArray(skList)) {
          examinees.forEach(examinee => {
            if (skList.includes(examinee.SK)) {
              examinee.is_report_generating = true;
            }
          });
        }
      }
      notification.warning({
        title: "요청 성공",
        description: "결과리포트_학생용 생성요청이 성공 했습니다.",
        duration: 3000,
      });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) ||
          "결과리포트_학생용 생성요청이 실패 했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    notification.error({
      title: "요청 실패",
      description: error || "결과리포트_학생용 생성요청이 실패 했습니다.",
      duration: 3000,
    });
  } finally {
    isStudentReporting.value[projectSK] = false;
    isDoingJob.value = false;
  }
}

async function doRequestProjectClose(projectSK: string) {
  showActionDialog({
    title: "확인",
    content: () =>
      h("div", null, [
        h(
          "p",
          { style: { color: "red", fontWeight: "bold" } },
          "정말로 검사를 종료하시겠습니까?"
        ),
        h("p", "검사를 종료하면 되돌릴 수 없으며, 리포트 생성이 불가능합니다."),
      ]),
    positiveText: "네",
    negativeText: "아니요",
    positiveButtonProps: { type: "default" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      isDoingJob.value = true;
      isProjectClosing.value[projectSK] = true;
      try {
        const result = await closeOneProjectCallable({
          SK: projectSK,
        });
        if (common.evalFunctionResult(result)) {
          notification.warning({
            title: "요청 성공",
            description: "검사 종료 및 이메일 전송요청이 성공 했습니다.",
            duration: 3000,
          });
        } else {
          notification.error({
            title: "요청 실패",
            description:
              common.getResultError(result) ||
              "검사 종료 및 이메일 전송요청이 실패 했습니다.",
            duration: 3000,
          });
        }
      } catch (error: any) {
        notification.error({
          title: "요청 실패",
          description: error || "검사 종료 및 이메일 전송요청이 실패 했습니다.",
          duration: 3000,
        });
      } finally {
        isProjectClosing.value[projectSK] = false;
        isDoingJob.value = false;
      }
    },
  });
}
async function scrollToClass(index: number) {
  if (
    !orderProjectEntries.value ||
    index < 0 ||
    index >= orderProjectEntries.value.length
  ) {
    return; // 유효하지 않은 인덱스 처리
  }
  activeClassIndex.value = index;

  const targetProject = orderProjectEntries.value[index];
  if (targetProject && targetProject.SK) {
    await fetchSingleProjectDetails(targetProject.SK, index);
  }
}

// 진단 type에 따라 그룹화된 항목들을 반환하는 computed 속성
const groupedProjectEntries = computed(() => {
  const groups: {
    type: string;
    title: string;
    entries: (Project & { originalIndex: number })[];
  }[] = [];
  const typeMap: { [type: string]: (Project & { originalIndex: number })[] } =
    {};

  orderProjectEntries.value?.forEach((entry, originalIndex) => {
    if (!typeMap[entry.type]) {
      typeMap[entry.type] = [];
    }
    typeMap[entry.type].push({ ...entry, originalIndex });
  });

  // Map 객체를 배열로 변환하고, 각 그룹에 제목 추가
  for (const type in typeMap) {
    if (Object.prototype.hasOwnProperty.call(typeMap, type)) {
      // 정렬 로직 추가: 학년(grade) 올림차순 -> 반(class) 올림차순
      typeMap[type].sort((a, b) => {
        const gradeA = String(a.grade || "");
        const gradeB = String(b.grade || "");

        if (gradeA !== gradeB) {
          return gradeA.localeCompare(gradeB, undefined, { numeric: true });
        }

        const classA = String(a.class || "");
        const classB = String(b.class || "");
        return classA.localeCompare(classB, undefined, { numeric: true });
      });

      groups.push({
        type: type,
        title: common.getProjectName(type), // 그룹 제목을 가져오는 함수 사용
        entries: typeMap[type],
      });
    }
  }
  return groups; // 필요시 여기서 그룹 순서를 정렬할 수 있습니다.
});

function getOriginalIndex(item: Project & { originalIndex?: number }): number {
  if (item.originalIndex !== undefined) {
    return item.originalIndex;
  }
  return (
    orderProjectEntries.value?.findIndex((entry) => entry.SK === item.SK) ?? -1
  );
}

function getClassItemTitle(
  classItem: Project & { originalIndex?: number }
): string {
  const isUniversityType =
    classItem.type === "putt_u" || classItem.type === "tec";
  if (isUniversityType) {
    return `${classItem.major} ${classItem.grade}`;
  } else {
    return `${classItem.grade}학년 ${classItem.class}반`;
  }
}
function handleCancel() {
  router.push({ name: USER_ROUTES.Mypage.Order.Org.Name });
}

function getOrgId() {
  const localAuth = common.getLocalAuth();
  if (localAuth && "orgId" in localAuth && localAuth.orgId) {
    return localAuth.orgId;
  }
  const orderSKFromRoute = route.params.SK as string;
  if (orderSKFromRoute) {
    const parts = orderSKFromRoute.split("#");
    if (parts[0] === "org" && parts[1] === "org") {
      return parts[2];
    } else if (parts[0] === "org") {
      return parts[1];
    }
  }
  return "";
}

async function openManagerSelectModalForDetail() {
  isManagerModalOpen.value = true;
  loadingMembers.value = true;
  orgMembers.value = [];
  memberSearchQuery.value = "";
  isIncludeAdmin.value = false;
  try {
    const orgId = getOrgId();
    if (!orgId) {
      notification.error({
        title: "오류",
        description: "기관 식별자를 찾을 수 없습니다.",
        duration: 3000,
      });
      return;
    }
    const result = await getOrgMembersCallable({ orgId });
    const list = common.getItemListFromFunctionResult(result) || [];
    orgMembers.value = list;
  } catch (error) {
    console.error("기관 멤버 조회 실패:", error);
    notification.error({
      title: "오류",
      description: "기관 멤버 정보를 불러오는데 실패했습니다.",
      duration: 3000,
    });
  } finally {
    loadingMembers.value = false;
  }
}

async function selectManager(row: any) {
  if (!orderProjectEntries.value || !orderProjectEntries.value[activeClassIndex.value]) {
    return;
  }
  const project = orderProjectEntries.value[activeClassIndex.value];
  const managerId = row.SK.split("#").pop() || "";

  isUpdatingManager.value = true;
  try {
    const params = {
      SK: project.SK,
      email: row.email,
      manager_name: row.name,
      manager_role: row.role || "",
      manager_position: row.position || "",
      manager_id: managerId,
    };
    const result = await updateProjectManagerCallable(params);
    if (common.evalFunctionResult(result)) {
      project.email = row.email;
      project.manager_name = row.name;
      project.manager_role = row.role || "";
      project.manager_position = row.position || "";
      project.manager_id = managerId;
      
      notification.success({
        title: "성공",
        description: "담당자가 정상적으로 변경되었습니다.",
        duration: 3000,
      });
      isManagerModalOpen.value = false;
    } else {
      notification.error({
        title: "실패",
        description: common.getResultError(result) || "담당자 변경에 실패했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    console.error("담당자 변경 오류:", error);
    notification.error({
      title: "오류",
      description: error || "담당자 변경 처리 중 오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    isUpdatingManager.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, pageLoading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MypageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(NSpace), { vertical: "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NCard), {
                class: "main-card",
                style: {"margin-top":"5px","margin-left":"5px","border":"0px","min-width":"800px","max-width":"1000px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    "item-style": "display: flex;",
                    align: "center",
                    justify: "space-between"
                  }, {
                    default: _withCtx(() => [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"font-size":"20px","font-weight":"bold"} }, " 진단 검사 정보 ", -1)),
                      _createVNode(_unref(NButton), {
                        onClick: refreshData,
                        type: "tertiary",
                        size: "small"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(NIcon), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(RefreshIcon))
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _cache[8] || (_cache[8] = _createTextVNode(" 새로고침 "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
                  (pageLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 진단 정보를 불러오는 중... "))
                    : (
                  !orderProjectEntries.value || orderProjectEntries.value.length === 0
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 진단 정보를 불러오지 못했습니다. "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "list-title" }, "진단 그룹", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedProjectEntries.value, (group) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: group.type
                              }, [
                                _createElementVNode("h5", _hoisted_9, _toDisplayString(group.title), 1),
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.entries, (classItem) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: classItem.SK,
                                      class: _normalizeClass({
                          'list-item': true,
                          active:
                            activeClassIndex.value === getOriginalIndex(classItem),
                        }),
                                      onClick: ($event: any) => (scrollToClass(getOriginalIndex(classItem)))
                                    }, _toDisplayString(getClassItemTitle(classItem)), 11, _hoisted_10))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            (orderProjectEntries.value && orderProjectEntries.value.length > 0)
                              ? (_openBlock(), _createBlock(_unref(NCard), {
                                  key: 0,
                                  title: 
                      getClassTitle(
                        orderProjectEntries.value[activeClassIndex.value],
                        activeClassIndex.value
                      )
                    ,
                                  size: "small",
                                  style: {"margin-bottom":"25px","border":"1px solid #dcdfe6","box-shadow":"0 1px 5px rgba(0, 0, 0, 0.07)"}
                                }, {
                                  default: _withCtx(() => [
                                    (orderProjectEntries.value[activeClassIndex.value])
                                      ? (_openBlock(), _createBlock(_unref(NDescriptions), {
                                          key: 0,
                                          "label-placement": "left",
                                          "label-style": "width: 130px;",
                                          column: 2,
                                          bordered: "",
                                          size: "small",
                                          style: {"margin-bottom":"15px"}
                                        }, {
                                          default: _withCtx(() => [
                                            (
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.ING
                        )
                                              ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                                  key: 0,
                                                  label: "검사 이름"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(common.getProjectName(
                            orderProjectEntries.value[activeClassIndex.value].type
                          ) || orderProjectEntries.value[activeClassIndex.value].name), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_12, [
                                                  _createElementVNode("span", null, _toDisplayString(_unref(getProjectStatusString)(
                                orderProjectEntries.value[activeClassIndex.value].status
                              )), 1),
                                                  (
                              orderProjectEntries.value[activeClassIndex.value].status ===
                              constant.projectStatus.PENDING
                            )
                                                    ? (_openBlock(), _createBlock(_unref(NButton), {
                                                        key: 0,
                                                        style: {"margin-left":"10px"},
                                                        type: "primary",
                                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (
                              doOpenProject(
                                orderProjectEntries.value[activeClassIndex.value].SK
                              )
                            )),
                                                        disabled: isDoingJob.value,
                                                        loading: 
                              isProjectOpening.value[
                                orderProjectEntries.value[activeClassIndex.value].SK
                              ]
                            
                                                      }, {
                                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                          _createTextVNode(" 진단검사 실시 ")
                                                        ])),
                                                        _: 1
                                                      }, 8, ["disabled", "loading"]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 1
                                            }),
                                            (
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.ING
                        )
                                              ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                                  key: 1,
                                                  label: "검사 링크",
                                                  span: 2
                                                }, {
                                                  default: _withCtx(() => [
                                                    (
                            orderProjectEntries.value[activeClassIndex.value]
                              .responder_uri &&
                            orderProjectEntries.value[activeClassIndex.value].status ==
                              constant.projectStatus.ING
                          )
                                                      ? (_openBlock(), _createElementBlock("a", {
                                                          key: 0,
                                                          href: common.getSurveyUrl(orderProjectEntries.value[activeClassIndex.value].SK!),
                                                          target: "_blank",
                                                          rel: "noopener noreferrer"
                                                        }, _toDisplayString(common.getSurveyUrl(
                              orderProjectEntries.value[activeClassIndex.value].SK!
                            )), 9, _hoisted_13))
                                                      : (
                            orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.COMPLETED
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " 종료된 검사 입니다. "))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_15, " 검사가 활성화 되면 링크가 표시됩니다. "))
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.ING
                        )
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  (
                            orderProjectEntries.value[activeClassIndex.value].type ===
                              'putt_u' ||
                            orderProjectEntries.value[activeClassIndex.value].type === 'tec'
                          )
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createVNode(_unref(NDescriptionsItem), { label: `전공` }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(orderProjectEntries.value[activeClassIndex.value].major ||
                              "N/A"), 1)
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_unref(NDescriptionsItem), { label: `학년` }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(orderProjectEntries.value[activeClassIndex.value].grade ||
                              "N/A"), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ], 64))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createVNode(_unref(NDescriptionsItem), { label: `학년` }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(orderProjectEntries.value[activeClassIndex.value].grade ||
                              "N/A"), 1)
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_unref(NDescriptionsItem), { label: `반` }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(orderProjectEntries.value[activeClassIndex.value].class ||
                              "N/A"), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ], 64))
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.ING
                        )
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                  _createVNode(_unref(NDescriptionsItem), { label: "진단 시작일" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(common.getYYYMMDDStringFormat(
                              orderProjectEntries.value[activeClassIndex.value]
                                .start_target_date
                            )), 1)
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(NDescriptionsItem), { label: "진단 종료일" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(common.getYYYMMDDStringFormat(
                              orderProjectEntries.value[activeClassIndex.value]
                                .end_target_date
                            )), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (
                          orderProjectEntries.value[activeClassIndex.value]
                            .teacher_report_file
                        )
                                              ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                                  key: 4,
                                                  label: "담임용 리포트",
                                                  span: 2
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(NButton), {
                                                      type: "primary",
                                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (
                              downloadTeacherReportFile(
                                orderProjectEntries.value[activeClassIndex.value]
                              )
                            ))
                                                    }, {
                                                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                        _createTextVNode(" 다운로드 ")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                                  key: 5,
                                                  label: "담임용 결과리포트",
                                                  span: 2
                                                }, {
                                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                    _createTextVNode(" N/A ")
                                                  ])),
                                                  _: 1
                                                })),
                                            _createVNode(_unref(NDescriptionsItem), {
                                              label: "담당자",
                                              span: 2
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_16, [
                                                  (orderProjectEntries.value[activeClassIndex.value].email)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                        _createTextVNode(_toDisplayString(orderProjectEntries.value[activeClassIndex.value].manager_name || '이름 없음') + " (" + _toDisplayString(orderProjectEntries.value[activeClassIndex.value].email) + ") ", 1),
                                                        (orderProjectEntries.value[activeClassIndex.value].manager_role || orderProjectEntries.value[activeClassIndex.value].manager_position)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " / " + _toDisplayString(orderProjectEntries.value[activeClassIndex.value].manager_role || '-') + " / " + _toDisplayString(orderProjectEntries.value[activeClassIndex.value].manager_position || '-'), 1))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_19, "지정된 담당자가 없습니다.")),
                                                  (_unref(isOrgAdmin))
                                                    ? (_openBlock(), _createBlock(_unref(NButton), {
                                                        key: 2,
                                                        size: "tiny",
                                                        type: "info",
                                                        ghost: "",
                                                        onClick: openManagerSelectModalForDetail
                                                      }, {
                                                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                          _createTextVNode(" 담당자 변경 ")
                                                        ])),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 1
                                            }),
                                            (
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.READY ||
                          orderProjectEntries.value[activeClassIndex.value].status ==
                            constant.projectStatus.ING
                        )
                                              ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                                  key: 6,
                                                  label: "진단검사분석요청",
                                                  span: 2
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_20, [
                                                      (
                              orderProjectEntries.value[activeClassIndex.value].type !=
                              'tec'
                            )
                                                        ? (_openBlock(), _createBlock(_unref(NTooltip), {
                                                            key: 0,
                                                            trigger: "hover"
                                                          }, {
                                                            trigger: _withCtx(() => [
                                                              _createVNode(_unref(NButton), {
                                                                size: "small",
                                                                disabled: isDoingJob.value || orderProjectEntries.value[activeClassIndex.value].is_teacher_report_generating,
                                                                loading: 
                                  isTeacherReporting.value[
                                    orderProjectEntries.value[activeClassIndex.value].SK
                                  ] || orderProjectEntries.value[activeClassIndex.value].is_teacher_report_generating
                                ,
                                                                type: "primary",
                                                                onClick: _cache[2] || (_cache[2] = ($event: any) => (
                                  doRequestTeacherReport(
                                    orderProjectEntries.value[activeClassIndex.value].SK
                                  )
                                ))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(orderProjectEntries.value[activeClassIndex.value].is_teacher_report_generating ? '레포트 생성 중...' : '결과리포트_담임용 생성요청'), 1)
                                                                ]),
                                                                _: 1
                                                              }, 8, ["disabled", "loading"])
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" " + _toDisplayString(getClassTitle(
                                orderProjectEntries.value[activeClassIndex.value],
                                activeClassIndex.value
                              )) + "의 학생목록의 결과리포트를 종합하는 담임용 리포트 생성을 요청합니다. ", 1)
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      _createVNode(_unref(NTooltip), { trigger: "hover" }, {
                                                        trigger: _withCtx(() => [
                                                          _createVNode(_unref(NButton), {
                                                            size: "small",
                                                            disabled: isDoingJob.value,
                                                            loading: 
                                  isStudentReporting.value[
                                    orderProjectEntries.value[activeClassIndex.value].SK
                                  ]
                                ,
                                                            type: "primary",
                                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (
                                  doRequestExamineeReport(
                                    orderProjectEntries.value[activeClassIndex.value].SK
                                  )
                                ))
                                                          }, {
                                                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                              _createTextVNode(" 결과리포트_학생용 생성요청 ")
                                                            ])),
                                                            _: 1
                                                          }, 8, ["disabled", "loading"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" " + _toDisplayString(getClassTitle(
                                orderProjectEntries.value[activeClassIndex.value],
                                activeClassIndex.value
                              )) + "의 모든 학생들에 대해서 개별 리포트 생성을 요청합니다. ", 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_unref(NTooltip), { trigger: "hover" }, {
                                                        trigger: _withCtx(() => [
                                                          _createVNode(_unref(NButton), {
                                                            size: "small",
                                                            disabled: isDoingJob.value,
                                                            loading: 
                                  isProjectClosing.value[
                                    orderProjectEntries.value[activeClassIndex.value].SK
                                  ]
                                ,
                                                            type: "primary",
                                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (
                                  doRequestProjectClose(
                                    orderProjectEntries.value[activeClassIndex.value].SK
                                  )
                                ))
                                                          }, {
                                                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                              _createTextVNode(" 검사 종료 및 결과리포트_학생용 전송 요청 ")
                                                            ])),
                                                            _: 1
                                                          }, 8, ["disabled", "loading"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" " + _toDisplayString(getClassTitle(
                                orderProjectEntries.value[activeClassIndex.value],
                                activeClassIndex.value
                              )) + "의 검사를 종료하고, 검사결과를 개별 학생들에게 전송하도록 요청합니다. ", 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (
                        orderProjectEntries.value[activeClassIndex.value].examinees &&
                        orderProjectEntries.value[activeClassIndex.value].examinees.length >
                          0
                      )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                          _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "examinee-section-title" }, "학생 목록", -1)),
                                          _createVNode(ExamineeTable, {
                                            examinees: 
                          orderProjectEntries.value[activeClassIndex.value].examinees
                        ,
                                            status: orderProjectEntries.value[activeClassIndex.value].status,
                                            classType: orderProjectEntries.value[activeClassIndex.value].type,
                                            project: orderProjectEntries.value[activeClassIndex.value]
                                          }, null, 8, ["examinees", "status", "classType", "project"])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_22, " 등록된 학생 정보가 없습니다. "))
                                  ]),
                                  _: 1
                                }, 8, ["title"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(NButton), {
                  type: "primary",
                  onClick: handleCancel
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode(" 목록으로 ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_unref(NModal), {
      show: isManagerModalOpen.value,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((isManagerModalOpen).value = $event)),
      preset: "card",
      title: "담당자 지정",
      style: {"width":"700px","max-width":"90%"},
      bordered: false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NSpace), {
          vertical: "",
          size: 12
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NSpace), {
              align: "center",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: memberSearchQuery.value,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((memberSearchQuery).value = $event)),
                  placeholder: "이름 또는 이메일 검색",
                  clearable: "",
                  style: {"width":"250px"},
                  disabled: isUpdatingManager.value
                }, null, 8, ["value", "disabled"]),
                _createVNode(_unref(NCheckbox), {
                  checked: isIncludeAdmin.value,
                  "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((isIncludeAdmin).value = $event)),
                  disabled: isUpdatingManager.value
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode(" 관리자 포함 ")
                  ])),
                  _: 1
                }, 8, ["checked", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NDataTable), {
              loading: loadingMembers.value || isUpdatingManager.value,
              columns: memberTableColumns,
              data: filteredOrgMembers.value,
              pagination: { pageSize: 5 },
              "row-key": (row) => row.SK
            }, null, 8, ["loading", "data", "row-key"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})